"use client";
import { SubHeader } from "components/earn";

export default function EarnLayout({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  return (
    <>
      <main className="relative overflow-hidden px-4">
        <SubHeader /> {children}
      </main>
    </>
  );
}
